module.exports = __webpack_public_path__ + "img/Twitter-Logo.wine.019a1488.svg";